import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-floating-chat',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floating-chat.component.html',
  styleUrl: './floating-chat.component.scss'
})
export class FloatingChatComponent {
  @Input() phone = '51999999999';
  @Input() advisorName = 'Malena Flores';
  @Input() advisorRole = 'Asesora Comercial';
  @Input() presetMessage = 'Hola, me gustaría recibir información sobre sus equipos.';
  @Input() avatarUrl?: string;
  @Input() online = true;

  open = false;

  toggle(){ this.open = !this.open; }
  close(){ this.open = false; }

  openWhatsApp(){
    const msg = encodeURIComponent(this.presetMessage);
    window.open(`https://wa.me/${this.phone}?text=${msg}`, '_blank');
  }
}
